import { deepCopyAggs } from "./deepCopyAggs";
import { deepCopyBetGroup } from "./deepCopyBetGroup";
import { deepCopySportAggs } from "./deepCopySportAggs";

export function getLiveAggs(sportId = null, aggId = null) {
    const aggsList = window.xs_ag.aggregateLiveByIdSport;
    if (sportId == null && aggId == null) {
        return deepCopySportAggs(aggsList);
    } else if (aggId == null) {
        return deepCopyAggs(aggsList[sportId]);
    } else {
        const agg = aggsList[sportId][aggId];
        return agg != null ? deepCopyBetGroup(agg): null;
    }
}
